// extracted by mini-css-extract-plugin
export var dropdownButton = "_1z-0";
export var fullWidthDropdownButton = "_1z-1";
export var icon = "_1z-3";
export var iconPlaceholder = "_1z-2";
export var shortcutContainer = "_1z-4";